import React from 'react';

export const OfflineSVGIcon = (props) => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" {...props}>
      <path
        d="M26.75 19.75H9.25V16.25H26.75M18 0.5C15.7019 0.5 13.4262 0.952651 11.303 1.83211C9.17984 2.71157 7.25066 4.00061 5.62563 5.62563C2.34374 8.90752 0.5 13.3587 0.5 18C0.5 22.6413 2.34374 27.0925 5.62563 30.3744C7.25066 31.9994 9.17984 33.2884 11.303 34.1679C13.4262 35.0474 15.7019 35.5 18 35.5C22.6413 35.5 27.0925 33.6563 30.3744 30.3744C33.6563 27.0925 35.5 22.6413 35.5 18C35.5 15.7019 35.0474 13.4262 34.1679 11.303C33.2884 9.17984 31.9994 7.25066 30.3744 5.62563C28.7493 4.00061 26.8202 2.71157 24.697 1.83211C22.5738 0.952651 20.2981 0.5 18 0.5Z"
        fill="#EB2126"
      />
    </svg>
  );
};
